import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, RendererFactory2 } from '@angular/core';
import { Meta, DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { PerfilService } from 'src/app/services/perfil.service';
import { TarjetaService } from 'src/app/services/tarjeta.service';

@Component({
  selector: 'app-dowload-contact',
  standalone: true,
  imports: [],
  templateUrl: './dowload-contact.component.html',
  styleUrl: './dowload-contact.component.scss'
})
export class DowloadContactComponent implements OnInit {

    tarjeta: any;
    profile: any;

  constructor(
    private tarjetaService: TarjetaService,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    @Inject(DOCUMENT) private document: Document,
  ) {
  }



    ngOnInit(): void {

      this.route.paramMap.subscribe(params => {
        const idTarjeta = params.get('id');
        if (idTarjeta && !this.profile) {
          this.getTarjeta(idTarjeta);
        } 
      });
    
  }



  descargarVCF(): void {
    const { nombre, telefono, correo, direccion, wsp, cargo, imgProfile, linkProfile, imgProfileResize } = this.tarjeta;

    fetch(imgProfileResize)
      .then(response => response.blob())
      .then(blob => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
          const base64data = reader.result?.toString().split(',')[1] || '';
          const tituloLimpio = this.cleanHTML(cargo).replace(/[\r\n]+/g, ' - ');
          let vCardData = `BEGIN:VCARD
VERSION:3.0
PHOTO;ENCODING=BASE64;TYPE=JPEG:${base64data}
N:${nombre}
FN:${nombre}
TITLE:${tituloLimpio}
TEL;TYPE=WORK,VOICE:${telefono}
TEL;TYPE=CELL,VOICE:${wsp}
EMAIL;INTERNET:${correo}
ADR;WORK;PREF:;${direccion}
URL;WORK:${linkProfile}

END:VCARD`;

          const vcfBlob = new Blob([vCardData], { type: 'text/vcard' });
          const vcfUrl = URL.createObjectURL(vcfBlob);
          const a = document.createElement('a');
          a.href = vcfUrl;
          a.download = `${nombre}.vcf`;
          a.click();
        };
      })
      .catch(error => console.error("Error al cargar la imagen:", error));
  }


  cleanHTML(input: string): string {
    const doc = new DOMParser().parseFromString(input, 'text/html');
    return doc.body.textContent || '';
  }


  getTarjeta(codigo: any){
    this.spinner.show();
    this.tarjetaService.getTarjetaByCode(codigo).subscribe({
      next: (response) => {
        this.spinner.hide();
        this.tarjeta = response;
        this.descargarVCF();
      },
      error: (err) => {
        this.spinner.hide();
        console.error('Error al cargar la tarjeta:', err);
      },
    });
  }
}
